
// React Component
import React from 'react';
import '../styles/privacy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy">

      <div className="privacy-section">
        <p><strong>Privacy Information</strong></p>
        <p><strong>Last updated:</strong> 9 October 2025</p>
        <p><strong>Version:</strong> 0.12</p>
        <p>
          Framsys AB processes camera data in real time using AI to estimate age and gender segments on premises.
          No video or still images are recorded or stored. No identification of individuals takes place and we do not
          create profiles at the person or device level. Only anonymised and aggregated statistics are stored, such as
          the number of visitors per hour and the distribution by age and gender segments.
        </p>

        <h2>Data Controller</h2>
        <p>Framsys AB, organisation number: 3508771-6, [Blomstringevägen 12, 22150, Jomala].</p>
        <p>Contact for dataskydd: <a href="mailto:dpo@framsys.ax">dpo@framsys.ax</a></p>

        <h2>Purpose of Processing</h2>
        <p>
          To understand customer flows and demographic distribution at an aggregated level in order to improve service,
          planning, and staffing.
        </p>

        <h2>Legal Basis</h2>
        <p>
          The processing is based on legitimate interests under Article 6(1)(f) of the GDPR.
        </p>
        <p>
          A Legitimate Interest Assessment (LIA) has been carried out and extensive safeguards have been implemented:
          no storage of image data, no identification, edge processing, masking of irrelevant areas, access control, and
          encryption.
        </p>

        <h2>Categories of Data Processed</h2>
        <ul>
          <li>Camera frames analysed temporarily in memory (RAM) on an edge device, with no storage or transmission of images.</li>
          <li>Aggregated statistics on number of people, gender segments, and age groups.</li>
          <li>Technical operational data without image content.</li>
        </ul>

        <h2>Retention</h2>
        <ul>
          <li>Image data is never stored.</li>
          <li>Aggregated statistics are stored up to 120 months and used only for trend analysis.</li>
        </ul>

        <h2>Recipients and Sharing</h2>
        <ul>
          <li>Data is shared only with authorised personnel within Framsys and any processors handling operations and analysis.</li>
          <li>No images or identifiable data are shared or sold.</li>
        </ul>

        <h2>Transfers Outside the EU/EEA</h2>
        <p>
          Framsys does not, as a rule, transfer data outside the EU/EEA. If exceptions occur, the European Commission’s
          Standard Contractual Clauses are used and a transfer impact assessment is performed.
        </p>

        <h2>Security and Privacy Protection</h2>
        <ul>
          <li>All analysis takes place locally on an edge device; no images leave the device.</li>
          <li>Recording functions are disabled and no facial recognition, tracking, or biometric identification is used.</li>
          <li>Data minimisation is applied by masking irrelevant areas.</li>
          <li>Encryption, logging, and access controls are used.</li>
          <li>Model accuracy and bias are continuously monitored and improved.</li>

        </ul>

        <h2>AI Act</h2>
        <p>
          The system constitutes biometric categorisation for gender and age under the EU AI Act but does not process sensitive
          attributes such as ethnicity, religion, political opinion, or sexual orientation. The transparency requirement is fulfilled
          through clear on-site signage (layer 1) and this page (layer 2).
        </p>

        <h2>Your Rights</h2>
        <p>
          You have the right to information, access, erasure, restriction, data portability, and to object to the processing.
          As no identification takes place, the processing falls under Article 11 of the GDPR, which means we do not collect
          additional data in order to identify an individual. Objections can be sent to <a href="mailto:dpo@framsys.ax">dpo@framsys.ax</a> and we will assess them without undue delay.
        </p>

        <h2>Complaints</h2>
        <p>
          If you believe the processing violates the GDPR, you have the right to lodge a complaint with the Swedish Authority for
          Privacy Protection (IMY).
        </p>

        <h2>Source of the Data</h2>
        <p>
          The data is collected directly via cameras on our premises. No personal data are purchased from third parties.
        </p>

        <h2>Fair and Lawful Processing</h2>
        <p>
          Processing is limited to what is necessary, used only in aggregated form, and does not lead to decisions affecting
          individual persons.
        </p>

        <h2>Changes to This Information</h2>
        <p>
          This information may be updated if technology, law, or purposes change. The date above indicates when the page was
          last updated.
        </p>

        <h2>Glossary</h2>
        <ul>
          <li><strong>Aggregated/anonymised statistics</strong> – data that cannot be linked to an individual.</li>
          <li><strong>Biometric categorisation</strong> – AI that places people into categories based on biometric features without identifying them.</li>
          <li><strong>Edge device</strong> – local hardware that analyses data on site.</li>
          <li><strong>LIA</strong> – Legitimate Interest Assessment under the GDPR.</li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
